<template>
<aside class="popup popup--wide | darkener is-open" v-if="open">
    <div class="popup__content | block">
        <h3 class="popup__title | title title--m" v-html="title"></h3>

        <p class="popup__text" v-if="text" v-html="text"></p>

        <div class="formCheckbox popup__dont-show">
            <input class="formCheckbox__input" type="checkbox" id="dam-popup-dont-show" v-model="dontShow">
            <label class="formCheckbox__label" for="dam-popup-dont-show">
                <span v-html="dontShowLabel"></span>
            </label>
        </div>

        <div class="popup__actions">
            <a :href="url" target="_blank" rel="noopener" class="btn btn--cta-alt" @click="onContinue"><span v-html="continueBtnLabel"></span></a>
            <button class="btn btn--subdued" @click="onClose"><span v-html="closeBtnLabel"></span></button>
        </div>

        <button class="popup__close" @click.prevent="onClose">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.875 3.32812L10.2031 8L14.875 12.6719C15.1771 12.974 15.3281 13.3438 15.3281 13.7812C15.3281 14.2083 15.1771 14.5729 14.875 14.875C14.5729 15.1667 14.2031 15.3125 13.7656 15.3125C13.3281 15.3125 12.9635 15.1667 12.6719 14.875L8 10.2031L3.32812 14.875C3.03646 15.1667 2.66667 15.3125 2.21875 15.3125C1.78125 15.3125 1.41667 15.1667 1.125 14.875C0.822917 14.5729 0.671875 14.2083 0.671875 13.7812C0.671875 13.3438 0.822917 12.974 1.125 12.6719L5.79688 8L1.125 3.32812C0.822917 3.02604 0.671875 2.66146 0.671875 2.23438C0.671875 1.79688 0.822917 1.42708 1.125 1.125C1.41667 0.833333 1.78125 0.6875 2.21875 0.6875C2.66667 0.6875 3.03646 0.833333 3.32812 1.125L8 5.79688L12.6719 1.125C12.9635 0.833333 13.3281 0.6875 13.7656 0.6875C14.2031 0.6875 14.5729 0.833333 14.875 1.125C15.0208 1.27083 15.1302 1.44271 15.2031 1.64062C15.2865 1.82812 15.3281 2.02604 15.3281 2.23438C15.3281 2.44271 15.2865 2.64062 15.2031 2.82812C15.1302 3.01562 15.0208 3.18229 14.875 3.32812Z" fill="#464646"/>
            </svg>
        </button>
    </div>
</aside>
</template>

<script>
import EventBus from '../../EventBus.vue'

const COOKIE_NAME = 'dam_popup_skip'
const COOKIE_DAYS = 365

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'DamLinkModal',

    data() {
        const i18n = window.vueapp_damLinkModal || {}
        return {
            open: false,
            url: null,
            dontShow: false,
            title: i18n.title || '',
            text: i18n.text || null,
            continueBtnLabel: i18n.continue || 'Continue',
            closeBtnLabel: i18n.close || 'Close',
            dontShowLabel: i18n.dont_show || "Don't show this again",
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        EventBus.$on('dam-link-modal-open', (e) => {
            this.url = e.url
            this.dontShow = false
            this.open = true
        })
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {
        onContinue() {
            if (this.dontShow) this.setCookie()
            this.open = false
        },

        onClose() {
            if (this.dontShow) this.setCookie()
            this.open = false
        },

        setCookie() {
            const expires = new Date()
            expires.setDate(expires.getDate() + COOKIE_DAYS)
            document.cookie = COOKIE_NAME + '=1; expires=' + expires.toUTCString() + '; path=/'
        },
    },


}

</script>
